import React, {useEffect, useState} from "react";
import KdrForm from "./components/KdrForm";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import DeclarationSuccessPreview from "./components/DeclarationSuccessPreview";
import { useLocation, BrowserRouter } from "react-router-dom";
import { SubmissionProvider } from "./context/SubmissionContext";
import { getCaptchaKey } from "./api/captcha";
import LoadingIndicator from "@clayui/loading-indicator";

const pathurl = window.location.pathname;
localStorage.setItem("kdr-form-pathname", pathurl)

const AppRouter = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const view = params.get("view");

  switch (view) {
    case "form":
      return <KdrForm />;
    case "success":
      return <DeclarationSuccessPreview />;
    default:
      return <KdrForm />;
  }
};

const App: React.FC = () => {
  const [captchaKey, setCaptchaKey] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchKey = async () => {
      try {
        const key = await getCaptchaKey();
        setCaptchaKey(key);
      } catch (error) {
        console.error("Błąd podczas pobierania klucza reCAPTCHA:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchKey();
  }, []);

  return (loading
      ? (
      <div style={{display: "flex", justifyContent: "center", marginTop: "5rem"}}>
        <LoadingIndicator style={{margin: 0}} displayType="secondary" size="md"/>
      </div>
      ) : (
      <div className="container">
        <GoogleReCaptchaProvider reCaptchaKey={captchaKey ?? "6Ldgc1orAAAAAA6q-jewm-uV2nbvfT3-rV9iGie-"}>
          <SubmissionProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </SubmissionProvider>
        </GoogleReCaptchaProvider>
      </div>
      )
  );
};

export default App;
